import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { HpRespPersonalizationPanelSmallItem } from './HpRespPersonalizationPanelSmallItem';
import { HpRespPersonalizationPanelMainItem } from './HpRespPersonalizationPanelMainItem';

import styles from './HpRespPersonalizationPanel.scss';
import {
    trackPersonalizationPromoClick,
    trackPersonalizationItemClick,
    trackPersonalizationViewAll,
} from './helpers/PersonalizationTracking';

function onItemClick({ item, variant, url, index }) {
    trackPersonalizationPromoClick();
    trackPersonalizationItemClick({ item, variant, url, index });
}

function onViewAllClick({ variant }) {
    trackPersonalizationPromoClick();
    trackPersonalizationViewAll({ variant });
}

function HpRespPersonalizationPanel({ item, isVisible, pageIndex }) {
    const { items = [] } = item;
    const [mainItem, ...smallItems] = items;
    return (
        <div
            className={classnames(
                'rowFlex',
                styles.itemPageContainer,
                { [styles.active]: isVisible },
                styles.item
            )}
        >
            <div className={`colXs12 colXl6`}>
                <HpRespPersonalizationPanelMainItem
                    item={mainItem}
                    index={pageIndex}
                    categoryUrl={item.url}
                    categoryTitle={item.categoryTitle}
                    onItemClick={() =>
                        onItemClick({
                            item: mainItem,
                            variant: item.variant,
                            url: item.url,
                            index: pageIndex * items.length,
                        })
                    }
                    onViewAllClick={() => onViewAllClick({ variant: item.variant })}
                />
            </div>
            <div className={`colXs12 colXl6`}>
                <div className={`rowFlex ${styles.smallItemListContainer}`}>
                    {smallItems.map((product, productIndex) => (
                        <HpRespPersonalizationPanelSmallItem
                            key={product.serviceId}
                            item={product}
                            onClick={() =>
                                onItemClick({
                                    item: product,
                                    variant: item.variant,
                                    url: item.url,
                                    // adding +1 to index because mainItem takes first possition
                                    index: pageIndex * items.length + productIndex + 1,
                                })
                            }
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

HpRespPersonalizationPanel.propTypes = {
    item: PropTypes.object.isRequired,
    isVisible: PropTypes.bool,
    pageIndex: PropTypes.number,
};

export { HpRespPersonalizationPanel };
